import { AuthenticatedRoute } from "../routes/ProtectedRoutes.tsx";
import { PlaceProvider } from "../providers/PlaceProvider.tsx";
import { CampaignProvider } from "../views/Campaign/CampaignContext.tsx";
import Layout from "../views/Layout/Layout.tsx";
import SuspenseContainer from "../components/SuspenseContainer/SuspenseContainer.tsx";
import { Outlet } from "react-router-dom";

export const AppLayout = () => (
  <AuthenticatedRoute>
    <PlaceProvider>
      <CampaignProvider>
        <Layout>
          <SuspenseContainer>
            <Outlet />
          </SuspenseContainer>
        </Layout>
      </CampaignProvider>
    </PlaceProvider>
  </AuthenticatedRoute>
);
